<template>
    <div style="min-height: 100%; display: flex; flex-direction: column;">
        <ion-grid class="contacts-grid" fixed style="padding-bottom: 0; margin: 0; flex-grow: 0;">
            <ion-row>
                <ion-col>
                    <ion-item lines="none">
                        <h1>{{ $t('ncrypt.contacts_page.list_title') }}</h1>
                    </ion-item>
                </ion-col>
            </ion-row>
            <ion-row v-show="loaded && contacts.length" class="ion-hide-sm-down">
                <ion-col>
                    <ion-item lines="none">
                        <ion-label color="dark" class="ion-no-margin">
                          <strong>{{ $t('ncrypt.name') }}</strong>
                        </ion-label>
                    </ion-item>
                </ion-col>
                <ion-col>
                    <ion-item lines="none">
                        <ion-label color="dark" class="ion-no-margin">
                          <strong>{{ $t('ncrypt.email') }}</strong>
                        </ion-label>
                    </ion-item>
                </ion-col>
            </ion-row>
        </ion-grid>
        <!--<editor-fold desc="skeleton">-->
        <ion-grid v-if="!loaded" class="contacts-grid" fixed style=" margin: 0;">
            <ion-row v-for="n in 10" :key="`n${n}`">
                <ion-col size="12" size-sm>
                    <ion-item lines="none">
                        <ion-avatar slot="start">
                            <ion-skeleton-text animated style="width: 40px; height: 40px;"></ion-skeleton-text>
                        </ion-avatar>
                        <ion-label>
                            <h3>
                                <ion-skeleton-text animated style="width: 50%;"></ion-skeleton-text>
                            </h3>
                        </ion-label>
                    </ion-item>
                </ion-col>
                <ion-col class="ion-hide-sm-down">
                    <ion-item lines="none">
                        <ion-label>
                            <h3>
                                <ion-skeleton-text animated style="width: 60%;"></ion-skeleton-text>
                            </h3>
                        </ion-label>
                    </ion-item>
                </ion-col>
            </ion-row>
        </ion-grid>
        <!--</editor-fold>-->
        <ion-grid v-else v-show="contacts.length" class="contacts-grid" fixed style="margin: 0;">
            <ion-row v-for="contact in contactsFiltered" :key="contact.id" @click="open(contact.id)" button>
                <ion-col size="12" size-sm>
                    <ion-item lines="none">
                        <ion-avatar slot="start">
                            <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjYzVkYmZmIiBkPSJNMCAwaDUxMnY1MTJIMHoiLz48cGF0aCBkPSJNMjU2IDMwNGM2MS42IDAgMTEyLTUwLjQgMTEyLTExMlMzMTcuNiA4MCAyNTYgODBzLTExMiA1MC40LTExMiAxMTIgNTAuNCAxMTIgMTEyIDExMnptMCA0MGMtNzQuMiAwLTIyNCAzNy44LTIyNCAxMTJ2NTZoNDQ4di01NmMwLTc0LjItMTQ5LjgtMTEyLTIyNC0xMTJ6IiBmaWxsPSIjODJhZWZmIi8+PC9zdmc+"
                                 alt="">
                        </ion-avatar>
                        <ion-label class="ion-hide-sm-down">
                            <h3>{{ contact.display_name }}</h3>
                        </ion-label>
                        <ion-label v-if="contact.name" class="ion-hide-sm-up">
                            <h2>{{ contact.name }}</h2>
                            <h3 style="color:#666;">{{ contact.email }}</h3>
                        </ion-label>
                        <ion-label v-else class="ion-hide-sm-up">
                            <h2>{{ contact.email }}</h2>
                        </ion-label>
                    </ion-item>
                </ion-col>
                <ion-col class="ion-hide-sm-down">
                    <ion-item lines="none">
                        <ion-label>
                            <h2>{{ contact.email }}</h2>
                        </ion-label>
                    </ion-item>
                </ion-col>
            </ion-row>
        </ion-grid>
        <ion-item v-if="loaded && !contacts.length" lines="none" style="margin: auto; flex: 1; display: flex; padding-bottom: 20vh;">
            <ion-text style="margin: auto; text-align: center;">
                <h2>{{ $t('ncrypt.contacts_page.no_results') }}</h2>
                <h4>{{ $t('ncrypt.contacts_page.no_results_info_description') }}</h4>
            </ion-text>
        </ion-item>
    </div>
</template>

<script>
    import {ApiError} from "@/errors/ApiError";

    export default {
        computed: {
            contactsFiltered() {
                if (!this.search) {
                    return this.contacts;
                }

                return this.contacts.filter((contact) => {
                    return contact.display_name.includes(this.search);
                });
            }
        },
        data() {
            return {
                loaded: false,
                contacts: [],
            }
        },
        props: {
            search: {type: String},
        },
        methods: {
            open(id) {
                this.$router.push({name: 'contact', params: {id}})
            },
            retrieveContacts() {
                this.$http
                    .get('/contacts')
                    .then(({data}) => {
                        if (!data || !data.success) {
                            new ApiError(data);
                            return;
                        }

                        this.contacts = data.contacts;
                        this.loaded = true;
                    })
                    .catch(error => window.console.error(error));
            },
        },
        created() {
            this.retrieveContacts();
        },
    }
</script>
